var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5082_205591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.8431 42.3058L84.1878 33.9611L84.7422 30.4488C69.5379 16.6199 45.3669 18.1898 31.6565 33.7199C27.848 38.0319 25.0255 43.4103 23.519 48.9664L26.5066 48.5433L43.1961 45.7927L44.4825 44.4767C51.9048 36.3223 64.46 35.2263 73.029 42.162L75.8431 42.3058Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0787 48.7175C94.1618 41.6549 90.2222 35.3032 84.7465 30.4453L73.0333 42.1584C77.9801 46.1996 80.7941 52.2847 80.6756 58.6702V60.748C86.4306 60.748 91.0981 65.4154 91.0981 71.1705C91.0981 76.9255 86.4306 81.4787 80.6756 81.4787H59.801L57.7529 83.7045V96.209L59.801 98.1724H80.6756C95.6471 98.2909 107.881 86.362 107.999 71.3905C108.071 62.3137 103.594 53.8039 96.0787 48.7175Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9519 98.1726H59.8011V81.483H38.9519C37.4751 81.483 36.0194 81.1614 34.678 80.5479L31.7201 81.4534L23.3161 89.7982L22.584 92.6376C27.298 96.1964 33.0488 98.198 38.9519 98.1726Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9517 44.0324C23.976 44.1213 11.9116 56.3337 12.0005 71.3094C12.0513 79.6711 15.9571 87.5419 22.5838 92.6411L34.6778 80.5471C29.4305 78.1774 27.0989 72.0034 29.4686 66.7562C31.8383 61.509 38.0123 59.1774 43.2595 61.5471C45.57 62.5923 47.4234 64.4415 48.4686 66.7562L60.5626 54.6622C55.4169 47.9339 47.4192 44.0028 38.9517 44.0324Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5082_205591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 77.1732,
    fill: "white",
    transform: "translate(12 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloud);
export default __webpack_public_path__ + "static/media/google-cloud.3a89edcedb75210a56292ce41d9bb645.svg";
export { ForwardRef as ReactComponent };